module.exports = __webpack_public_path__ + "img/sustainability@2x.7e3e6ce.jpg";